import {
  CheckCircleRounded as CompletedIcon,
  HourglassEmptyRounded as PendingIcon,
  BuildCircleRounded as InProgressIcon,
  CancelRounded as CancelledIcon,
  HelpOutlineRounded,
  PauseCircleOutlineRounded,
  RateReviewRounded,
} from "@mui/icons-material";

// The status and priority vocabulary of a template request, in one module so
// the history list, the description cards and the URL filter validation all
// read the same keys.

export const STATUS_CONFIG = {
  SUBMITTED: {
    label: "Submitted",
    color: "info",
    icon: <PendingIcon />,
    description:
      "Your file has been submitted with changes required. Our engineers will review the details and begin work.",
  },
  IN_REVIEW: {
    label: "In Review",
    color: "warning",
    icon: <InProgressIcon />,
    description:
      "Cactus believes this is complete and is awaiting your confirmation that it has been done correctly.",
  },
  IN_PROGRESS: {
    label: "In Progress",
    color: "primary",
    icon: <InProgressIcon />,
    description: "A Cactus engineer is actively working on your template.",
  },
  COMPLETED: {
    label: "Completed",
    color: "success",
    icon: <CompletedIcon />,
    description: "Your template has been completed and accepted.",
  },
  CANCELLED: {
    label: "Cancelled",
    color: "error",
    icon: <CancelledIcon />,
    description: "This request has been cancelled and will not be worked on.",
  },
  NO_CHANGES_REQUIRED: {
    label: "No Changes",
    color: "default",
    icon: <CompletedIcon />,
    description:
      "Your file has been submitted and requires no changes — it will be processed with the required form number and name.",
  },
  INFO_NEEDED: {
    label: "Information Needed",
    color: "warning",
    icon: <HelpOutlineRounded />,
    description:
      "We need more information from you before we can continue. Please review the request and provide the requested details so our engineers can proceed.",
  },
  ON_HOLD: {
    label: "On Hold",
    color: "secondary",
    icon: <PauseCircleOutlineRounded />,
    description:
      "This request has been placed on hold and is paused for now. Work will resume once it is taken off hold.",
  },
  CHANGES_REQUESTED: {
    label: "Changes Requested",
    color: "error",
    icon: <RateReviewRounded />,
    description:
      "You have reviewed the template and requested changes. Our engineers will action the changes you have asked for.",
  },
};

export const STATUS_ORDER = [
  "SUBMITTED",
  "NO_CHANGES_REQUIRED",
  "IN_PROGRESS",
  "ON_HOLD",
  "CHANGES_REQUESTED",
  "INFO_NEEDED",
  "IN_REVIEW",
  "COMPLETED",
  "CANCELLED",
];

export const PRIORITY_CONFIG = {
  LOW: { label: "Low", color: "success" },
  MEDIUM: { label: "Medium", color: "warning" },
  HIGH: { label: "High", color: "error" },
};

export const PRIORITY_ORDER = ["LOW", "MEDIUM", "HIGH"];
